<template>
  <div class="function_intro">
    <h2 class="function_intro_title">{{ covertTitle }} 功能介绍</h2>
    <ul class="func_list g_ul">
      <li v-for="(item, index) in introList" :key="index" class="func_item">
        <div class="img">
          <i class="convert_icons" :class="`convert_icon_1_${index + 1}`" />
        </div>
        <h3 class="func_title">{{ item.title }}</h3>
        <p class="func_desc">{{ item.desc }}</p>
      </li>
    </ul>
  </div>
</template>

<script>
import { FILE_TYPE_CHINESE } from '@/config/config'
import { filetypeValidator } from '@/utils/shared'

export default {
  props: {
    covertTitle: {
      type: String,
      default: ''
    },

    fileType: {
      validator: filetypeValidator,
      required: true
    },

    toFileType: {
      type: String,
      required: true
    }
  },

  data () {
    return {
      introList: []
    }
  },

  created () {
    const fileTypeChinese = FILE_TYPE_CHINESE[this.fileType]
    const toFileTypeChinese = FILE_TYPE_CHINESE[this.toFileType]

    this.introList = [
      { title: `如何把${fileTypeChinese}转换成${toFileTypeChinese}`, desc: `点击按钮或者${fileTypeChinese}拉至拖放区，将文件上传至我们平台，文件转换完成后，您可以直接下载。` },
      { title: '超大文件任意转', desc: '高效办公，最大支持50M文件，一键批量转换。' },
      { title: '尊重隐私，确保文件安全', desc: '100%保障您的隐私，可在我的转换记录中手动删除这些文件。' },
      { title: `高质量${fileTypeChinese}转换${toFileTypeChinese}模式`, desc: `优化转换${fileTypeChinese}转化${toFileTypeChinese}乱码，排版问题，为您提供最优质的转换服务。` },
      { title: '快速高效转换', desc: '我们将自动上传转换文件，您只需稍等片刻将转换后文件下载即可。' },
      { title: '云转换服务', desc: `我们拥有多个将${fileTypeChinese}转换成${toFileTypeChinese}文件的云端服务器，支持批量快速转换操作。` }
    ]
  }
}
</script>

<style lang="scss">
  .function_intro { margin-top: 27px; }
  .function_intro_title { position: relative; padding-left: 15px; font-size: 20px; font-weight: bold; color: #333;
    &::before { position: absolute; top: 50%; left: 0; width: 3px; height: 20px; margin-top: -10px; content: ' '; background: #538df7; }
  }
  .func_list { width: 100%; margin: 22px -138px 0 0;
    .img { height: 80px; }
  }
  .func_item { width: 238px; height: 235px; margin: 34px 138px 0 0; text-align: center;
    &:nth-child(3n) { margin-right: 0; }
  }
  .func_title { margin-top: 15px; font-size: 18px; line-height: 30px; color: #333; }
  .func_desc { margin-top: 7px; font-size: 14px; line-height: 24px; color: #656565; }
</style>
